import { render, staticRenderFns } from "./UrlListWindow.vue?vue&type=template&id=35dd28c2&scoped=true&"
import script from "./UrlListWindow.vue?vue&type=script&lang=js&"
export * from "./UrlListWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dd28c2",
  null
  
)

export default component.exports